import { useState } from "react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thanks! We have received your inquiry.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="page">
      <header className="page__hero">
        <h1>Contact Us</h1>
        <p>Reach the admissions and student support team. We respond within 2 business days.</p>
      </header>

      <section className="section">
        <div className="section__inner contact-grid">
          <div className="contact-info">
            <div className="section__header section__header--left">
              <span className="section__tag">Get in Touch</span>
              <h2 className="section__title">We're here to help</h2>
              <p className="section__subtitle">
                Campus: BEDCO Leribe, Hlotse, Room 5. Visit us or send a note - let's talk about your study goals.
              </p>
            </div>

            <ul className="contact-list">
              <li><strong>Phone:</strong> +266 5627 7876 (WhatsApp)</li>
              <li><strong>Email:</strong> college@mokorotlocollege.co.ls</li>
              <li><strong>Address:</strong> BEDCO Leribe, Hlotse, Room 5 (Plus Code: 42FV+QP4)</li>
              <li><strong>Hours:</strong> Mon-Fri, 08:00-17:00</li>
            </ul>

            <div className="map-embed" aria-label="Map to Mokorotlo College">
              <iframe
                title="Mokorotlo College Location"
                src="https://www.google.com/maps?q=BEDCO+Leribe,+Hlotse,+42FV%2BQP4&output=embed"
                allowFullScreen
                loading="lazy"
              />
              <a className="map-embed__link" href="https://maps.google.com/?q=BEDCO+Leribe,+Hlotse,+42FV%2BQP4" target="_blank" rel="noopener noreferrer">
                Open in Google Maps
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label>
              Full Name
              <input name="name" value={form.name} onChange={handleChange} required />
            </label>
            <label>
              Email
              <input type="email" name="email" value={form.email} onChange={handleChange} required />
            </label>
            <label>
              Message
              <textarea name="message" rows="5" value={form.message} onChange={handleChange} required />
            </label>
            <button type="submit" className="btn btn--accent">Send Message</button>
          </form>
        </div>
      </section>
    </div>
  );
}
